/**
 *
 * @file 个人中心/我的消息api
 *
 **/

import AXIOS from '@/utils/$axios';

// 系统信息列表
export const getlist = params =>
    AXIOS.get('/hdc-admin/hdc/user/message/list', { params });

// 未读信息条数
export const getUnread = timeout =>
    AXIOS.get('/hdc-admin/hdc/user/message/unreadAmount', {
        timeout,
    });

// 删除消息
export const deleteMessage = id =>
    AXIOS.post(`/hdc-admin/hdc/user/message/delete/${id}`);

// 标为已读
export const markRead = payload =>
    AXIOS.post(`/hdc-admin/hdc/user/message/update`, payload);
